import './ProductAttributes.scss';
import Component from './ProductAttributes.js';
export default Component;
